import { ObjectSchema } from 'yup';
import {
	FieldValues,
	Resolver,
	UseFormProps,
	useForm as useReactHookForm,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export interface IUseFormOptions<
	TFieldValues extends FieldValues,
	TContext extends object,
> extends Omit<UseFormProps<TFieldValues, TContext>, 'resolver'> {
	validationSchema: ObjectSchema<TFieldValues>;
}

export function useForm<
	TFieldValues extends FieldValues = FieldValues,
	TContext extends object = object,
>(options: IUseFormOptions<TFieldValues, TContext>) {
	const { validationSchema, ...rest } = options;

	return useReactHookForm<TFieldValues, TContext>({
		...rest,
		resolver: yupResolver(validationSchema) as Resolver<
			TFieldValues,
			TContext,
			TFieldValues
		>,
	});
}
